export const unit_name = [
  "562 - Mars Wrigley South Europe MU",
  "51 - Arevalo (ARV)(Pet)",
  "529 - Global Pet Nutrition Division",
  "164 - Gainesville (GNV)(MW)",
  "343 - Aurora (NEA)(Pet)",
  "539 - Nature's Bakery NA BU",
  "132 - Waco (WAC)(MW)",
  "360 - M&M Retail Shanghai (SHA)",
  "488 - Foodspring BU",
  "301 - Pet Nutrition Mexico MU",
  "472 - Royal South Dakota (RSD)(Pet)",
  "511 - RC International Division MU",
  "169 - Taipei (TAP)(MW)",
  "368 - RC Iberia MU",
  "494 - Blonie (BLN)(Pet)",
  "133 - M&M Printing (HKP-P)",
  "480 - Experience Store Retail Unit",
  "585 - Kevin's Food BU",
  "559 - RC Latam MU",
  "342 - Henderson (NCH)(Pet)",
  "521 - Mars Health & Wellness Division",
  "146 - Descalvado (RCD)(Pet)",
  "230 - Pet Nutrition SEA MU",
  "52 - Bruck (BRK)(Pet)",
  "145 - Cambrai (RCC)(Pet)",
  "406 - RC Rapid Growth Markets BU",
  "556 - Pet Nutrition Brazil BU",
  "60 - Thomas's Birstall (THO)(Pet)",
  "479 - M&M Printing (HAG-P)",
  "387 - RC Pacific MU",
  "334 - Mars Inc. (Corp)",
  "89 - Bolton (BPP)(Pet)",
  "443 - Symbioscience BU",
  "464 - Ethel M sub-BU",
  "66 - Porici (PNS)(MW)",
  "233 - Pet Nutrition Australia MU",
  "323 - Pet Nutrition USA MU",
  "329 - Topeka (TOP)(MW)",
  "37 - Bokros (BOK)(Pet)",
  "478 - Pet Nutrition ANZ BU",
  "541 - KIND NA USA and Canada MU",
  "506 - Mars Wrigley Europe & Central Eurasia BU",
  "126 - Albany (ALB)(MW)",
  "46 - Chateaudun (CHD)(Food)",
  "561 - Mars Wrigley Central Europe MU",
  "586 - Champion Alberta (CPA)",
  "8 - Jiaxing (JXG) (MW)",
  "59 - St Denis (STD)(Pet)",
  "532 - M&M Retail US-Stores",
  "29 - Egypt October City (OCT)(MW)",
  "456 - Mars Wrigley China MU",
  "129 - Cleveland (CLV)(MW)",
  "12 - Wyong (MFA)(Food)",
  "121 - Victorville (VIC)(Pet)",
  "154 - Horsecare BU",
  "403 - RC Europe BU",
  "68 - Veghel (VEG)(MW)",
  "514 - Nom Nom Now sub-BU",
  "7 - Huairou (HUA)(MW)",
  "448 - Mars Wrigley China BU",
  "74 - Queretaro (QRO)(Pet)",
  "538 - KIND Frozen sub-BU",
  "61 - Verden (VDN)(Pet)",
  "149 - Virrey Del Pino (RVP)(Pet)",
  "522 - Science & Diagnostics Division",
  "560 - Mars Wrigley DACH MU",
  "130 - Elizabethtown (ELZ)(MW)",
  "422 - VCA BU",
  "168 - Shanghai (SON)(MW)",
  "517 - Tasty Bite (PBI) MU",
  "555 - Pet Nutrition Mexico BU",
  "152 - Castle Cary (RCS)(Pet)",
  "219 - Yonghe (YNG)(MW)",
  "527 - Linnaeus BU",
  "588 - RC Rapid Growth BU",
  "389 - RC India MU",
  "451 - Mars Wrigley LAN MU plus",
  "212 - Mars Wrigley Choco Drinks & Treats sub- BU",
  "366 - RC France MU",
  "385 - RC Korea MU",
  "415 - Blue Pearl BU",
  "551 - Pet Nutrition China BU",
  "377 - RC Mexico MU",
  "453 - Mars Wrigley Australia MU plus",
  "553 - Pet Nutrition Japan BU",
  "55 - Melton (MEL)(Pet)",
  "249 - Mars Wrigley Choco Drinks & Treats MU",
  "569 - Pet Nutrition France & Benelux MU",
  "75 - Montemorelos (MTM)(MW)",
  "473 - Henderson (NCD) (Pet)",
  "567 - Mars Wrigley CEAB & Turkey MU",
  "234 - Pet Nutrition China MU",
  "547 - Luwu Timur Cocoa Farm Indonesia",
  "16 - Wodonga (WOD) (Pet)",
  "296 - Multisales Andean MU",
  "427 - RC Eastern Southern Europe MU",
  "450 - Mars Wrigley USA MU",
  "64 - Steinbourg (DOE)(MW)",
  "115 - Mattoon (KKM)(Pet)",
  "577 - High Point KIND (KHP)",
  "178 - Biesheim (BHM)(MW)",
  "319 - Multisales Canada MU",
  "367 - RC Italy MU",
  "557 - Pet Nutrition South Latam BU",
  "571 - Pet Nutrition Central Europe MU",
  "317 - Food NA MU",
  "525 - Antech BU",
  "349 - Pilot Plant Thompson (TNT)(Pet)",
  "404 - RC North Americas BU",
  "492 - Tasty Bite (TBEL)(Food)",
  "549 - TruFru USA & Canada MU",
  "528 - Champion Petfoods Acquisition BU",
  "374 - RC UK MU",
  "54 - Gargzdai (GAR)(Pet)",
  "79 - Mogi Mirim (MOM)(Pet)",
  "153 - Guelph (RGU)(Pet)",
  "336 - Global Mars Petcare Segment",
  "474 - Chonburi (CHB) (Pet)",
  "120 - Lebanon (RLB)(Pet)",
  "331 - Mars Wrigley Asian Sourcing Team",
  "502 - M&M Retail Berlin(BRL)",
  "160 - Chattanooga (TNN)(MW)",
  "372 - RC Nordics MU",
  "124 - Kansas City (KAN)(Pet)",
  "344 - Fremont (RFT)(Pet)",
  "426 - RC Central Northern Europe MU",
  "180 - Nairobi (NAI)(MW)",
  "446 - Mars Wrigley GEM BU",
  "161 - West Chicago (AUR)(MW)",
  "537 - KIND Asia BU",
  "82 - Guararema (GUA)(MW)",
  "174 - Bangalore (BAN)(MW)",
  "148 - Rolla (RCR)(Pet)",
  "50 - Pet Nutrition Europe BU",
  "512 - Pretty Litter Acquisition BU",
  "531 - Global Mars Snacking Segment",
  "391 - RC South Africa MU",
  "287 - Fishcare MU",
  "179 - Poznan (POZ)(MW)",
  "580 - Carson City NB (NBP)",
  "424 - RC Hong Kong & Taiwan MU",
  "536 - KIND North America BU",
  "540 - TruFru NA BU",
  "93 - Pet Nutrition NA BU",
  "131 - Hackettstown (HKP)(MW)",
  "442 - Wisdom Health BU",
  "516 - Tasty Bite BU",
  "563 - Mars Wrigley Nordics MU",
  "14 - Bathurst (BTH) (Pet)",
  "27 - Hyderabad (HYD)(Pet)",
  "365 - Pune (PUN)(MW)",
  "229 - Multisales New Zealand MU",
  "297 - Multisales Southern Cone MU",
  "320 - Horsecare NA MU",
  "513 - KIND EMEA BU",
  "579 - Hazelwood NB (NBH)",
  "175 - Plymouth (PLY)(MW)",
  "544 - KIND Japan MU",
  "39 - Janaszowek (JAN)(MW)",
  "202 - Fort Smith (ARK)(Pet)",
  "314 - Mars Wrigley Ice Cream USA MU",
  "170 - Antipolo City (ATP)(MW)",
  "330 - King Abdullah Economic City (KEC)(MW)",
  "386 - RC China MU",
  "18 - Ballarat (MCA) (MW)",
  "48 - Oud Beijerland (OBL)(Food)",
  "566 - Multisales South Africa MU",
  "88 - Bolton (BFP)(Food)",
  "101 - Tomah (WIT)(Pet)",
  "421 - Toluca (TOT) (MW)",
  "445 - Mars Wrigley North America BU",
  "534 - Mumbai Bhiwandi (RMB)(Pet)",
  "143 - Global Royal Canin Division",
  "508 - Tianjin (TJN) (Pet)",
  "554 - Pet Nutrition SEA BU",
  "139 - Makassar (UJU)(MW)",
  "49 - Olen (OLN)(Food)",
  "76 - Santa Catarina (SCA)(MW)",
  "69 - Viersen (VSN)(MW)",
  "500 - RC South East Asia MU",
  "570 - Pet Nutrition UK, Ireland & Nordics MU",
  "117 - Reno (KKR)(Pet)",
  "293 - Multisales Brazil MU plus",
  "84 - Mercedes (MER)(Pet)",
  "47 - King's Lynn (KLN)(Food)",
  "373 - RC DACH MU",
  "564 - Mars Wrigley UK & Ireland MU",
  "92 - Greenville (GRV)(Food)",
  "199 - Yokohama (RYO)(Pet)",
  "150 - Dmitrov (RDM)(Pet)",
  "526 - Point of Care BU",
  "155 - Milton Keynes (MIL)(Horse)",
  "359 - M&M Retail London (LON)",
  "578 - TruFru UK MU",
  "151 - Niepolomice (RNI)(Pet)",
  "218 - Chalfont (CHA)(Fish)",
  "495 - Pilot Plant Aimargues (RCA) (Pet)",
  "208 - Shanghai (RSH)(Pet)",
  "313 - Ethel M MU",
  "501 - Birdcare sub-BU",
  "81 - Recife (REC)(Pet)",
  "371 - RC Benelux MU",
  "552 - Pet Nutrition India BU",
  "38 - Sochaczew (SOC)(Pet)",
  "337 - Global Mars Food & Nutrition Segment",
  "530 - MVH International Asia BU",
  "535 - Lewisburg  (ROH)(Pet)",
  "436 - RC Argentina MU",
  "509 - Nom Nom Nashville (RNT) (Pet)",
  "56 - Minden (MIN)(Pet)",
  "136 - Henderson (EGM)(MW)",
  "519 - La Chola Cocoa Farm Ecuador",
  "558 - Ponta Grossa (PGA)(Pet)",
  "65 - Haguenau (HAG)(MW)",
  "235 - Pet Nutrition India MU",
  "348 - Waltham Pet Science Institute BU",
  "465 - Mars Wrigley Division",
  "171 - Asquith (ASQ)(MW)",
  "173 - Baddi (BAD)(MW)",
  "419 - Banfield BU",
  "378 - RC Brazil MU",
  "565 - Mars Wrigley Benelux & ITR MU",
  "159 - Yorkville (YRV)(MW)",
  "487 - Multisales MEA MU plus",
  "144 - Aimargues (RCA)(Pet)",
  "67 - Slough (SLO)(MW)",
  "361 - Ethel M Stores (ETH)",
  "545 - KIND Korea MU",
  "523 - Whistle BU",
  "455 - Mars Wrigley India MU plus",
  "458 - Mars Wrigley France MU",
  "546 - KIND Singapore & HK MU",
  "53 - Ernolsheim (ERN)(Pet)",
  "520 - Global Food BU",
  "497 - Food EU MU",
  "127 - Burr Ridge (BUR)(MW)",
  "572 - Pet Nutrition South Europe MU",
  "147 - Johannesburg (RJH)(Pet)",
  "100 - Temple (TXT)(Pet)",
  "225 - Food Australia MU",
  "90 - Newmarket (NMK)(MW)",
  "157 - Wacol (UBW)(Bird)",
  "341 - Russellville (ARR)(Pet)",
  "524 - Anicura BU",
  "568 - Pet Nutrition DACH MU",
  "156 - Dalton (DAL)(Horse)",
  "4 - Pakchong (PCH)(Pet)",
  "405 - RC Asia Pacific BU",
  "118 - Columbia (KKS)(Pet)",
  "288 - Horsecare Europe MU",
  "490 - Multisales Asia MU plus",
  "582 - RC Eurasia MU",
  "587 - Champion Auburn (CPK)",
  "22 - Cape Town (CAP)(Food)",
  "114 - Columbus (KKC)(Pet)",
  "416 - Mars Veterinary Health Division",
  "496 - Pilot Plant Verden (VDN) (Pet)",
  "300 - Pet Nutrition Brazil MU",
  "548 - Nature's Bakery NA, CA & Mexico MU",
  "550 - Digital Business Unit (DBU) MU",
  "227 - Multisales Japan MU",
  "382 - RC Japan MU",
  "481 - Experience Store sub-BU",
  "438 - Gimje (RGY)(Pet)",
  "217 - Fishcare sub-BU",
  "543 - KIND UK MU",
  "376 - RC Canada MU",
  "581 - RC EKA MU",
  "346 - Leipsic (OHL)(Pet)",
  "73 - Guadalajara (GDL) (Pet)",
  "589 - Salt Lake City (SLC)"
];

export const unit_type = [
  "Not Available",
  "Business Unit",
  "Mfg Site",
  "Sub-Business Unit",
  "Division",
  "Segment",
  "Market Unit",
  "Region Unit",
  "Corporate",
  "Retail Unit",
];

export const segment = [
  "Not Available",
  "Mars Petcare",
  "Mars Snacking",
  "Mars Food & Nutrition",
  "obs. Drinks",
  "Multi-Sales",
  "Mars Corporate",
];

export const region = [
  "Not Available",
  "Asia Pac",
  "META",
  "CIS",
  "Europe",
  "Latin America",
  "North America",
  "Global",
  "Mars Wrigley Division",
  "Global Pet Nutrition Division",
];
export const country = [
  "Not Available",
  "Thailand",
  "China",
  "Australia",
  "South Africa",
  "India",
  "Egypt",
  "Russia",
  "Hungary",
  "Poland",
  "France",
  "UK",
  "Netherlands",
  "Belgium",
  "Germany",
  "Spain",
  "Austria",
  "Lithuania",
  "Czech Republic",
  "Mexico",
  "Brazil",
  "Argentina",
  "Canada",
  "USA",
  "Indonesia",
  "Taiwan, China",
  "Phillippines",
  "NULL",
  "Japan",
  "New Zealand",
  "Malaysia",
  "Kazakhstan",
  "Africa",
  "Turkey",
  "OPEN",
  "Saudi Arabia",
  "Italy",
  "Denmark",
  "Korea",
  "Ukraine",
  "Europe",
  "Romania",
  "Singapore",
];

export const siteCode = [
  "Not Available",
  "PCH",
  "HPT",
  "HUA",
  "JXG",
  "NULL",
  "MFA",
  "WOD",
  "BTH",
  "WGI",
  "MCA",
  "SCO",
  "SLC",
  "CAP",
  "EXR",
  "EXD",
  "HYD",
  "OCT",
  "LUK",
  "LUZ",
  "NOV",
  "STU",
  "BOK",
  "SOC",
  "JAN",
  "OBL",
  "CHD",
  "KLN",
  "OLN",
  "VDN",
  "ARV",
  "BRK",
  "ERN",
  "GAR",
  "MEL",
  "MIN",
  "MOG",
  "PBO",
  "STD",
  "THO",
  "SLO",
  "SLC",
  "BBN",
  "DOE",
  "HAG",
  "PNS",
  "VEG",
  "VSN",
  "GDL",
  "QRO",
  "MTM",
  "SCA",
  "GUA",
  "MOM",
  "REC",
  "MER",
  "BAR",
  "BFP",
  "BPP",
  "NMK",
  "FGI",
  "GRV",
  "BRN",
  "MOJ",
  "CAT",
  "SBE",
  "TXT",
  "WIT",
  "OHW",
  "PUE",
  "ORA",
  "OKM",
  "OKC",
  "MNL",
  "KKC",
  "KKM",
  "KKR",
  "KKS",
  "NSC RNS",
  "RLB",
  "VIC",
  "FRN",
  "KAN",
  "HKT",
  "ALB",
  "BUR",
  "CHI",
  "CLV",
  "ELZ",
  "HKP",
  "WAC",
  "MRG",
  "MTA",
  "EGM",
  "ROK",
  "UJU",
  "FSQ",
  "WCR",
  "RCA",
  "RCC",
  "RCD",
  "RJH",
  "RCR",
  "RVP",
  "RDM",
  "RNI",
  "RCS",
  "RGU",
  "MIL",
  "DAL",
  "UBW",
  "GIC",
  "YRV",
  "TNN",
  "AUR",
  "ONT",
  "GNV",
  "GNZ",
  "PNY",
  "SON",
  "TAP",
  "ATP",
  "ASQ",
  "STP",
  "BAD",
  "BAN",
  "PLY",
  "CAF",
  "BHM",
  "POZ",
  "NAI",
  "BOL",
  "RYO",
  "MTD",
  "ARK",
  "WUN",
  "WMO",
  "WCH",
  "MIR",
  "RSH",
  "OKF",
  "MDT",
  "CHE",
  "VAN",
  "CHA",
  "YNG",
  "MDJ",
  "MDS",
  "SEA",
  "TOK",
  "SEO",
  "AUK",
  "MKL",
  "TAI",
  "FSP",
  "FSV",
  "WAW",
  "EFX",
  "BRU",
  "PCZ",
  "ATH",
  "BUD",
  "DUB",
  "DOL",
  "EVE",
  "COP",
  "LIS",
  "BUC",
  "MAD",
  "ZUG",
  "WAL",
  "SGO",
  "CAI",
  "JED",
  "EXI",
  "WDU",
  "does not exist",
  "MDC",
  "TOP",
  "KEC",
  "AST",
  "MVA",
  "ARR",
  "NCH",
  "NEA",
  "RFT",
  "OHB",
  "OHL",
  "WCP",
  "TNT",
  "Mars Inc : Petcare : Petcare NA : TNT-PDC",
  "MTY",
  "LAS",
  "NYC",
  "ORD",
  "LON",
  "SHA",
  "ETH",
  "PUN",
  "RCF",
  "RCM",
  "RAD",
  "RCN",
  "COA",
  "RKO",
  "RMC",
  "SAO",
  "RSC",
  "RCJ",
  "RBT",
  "RCK",
  "RCP",
  "RSK",
  "RMU",
  "RSW",
  "RSA",
  "RKI",
  "RCEU",
  "RCAM",
  "RCAP",
  "RCES",
  "SPP",
  "TOT",
  "RHK",
  "IBU",
  "CNE",
  "RBC",
  "RND",
  "MAR",
  "BOA",
  "RGY",
  "GMD",
  "tbd",
  "NZA",
  "RIS",
  "NSC RSD",
  "NCD",
  "CHB",
  "KNY",
  "BER",
  "TBE",
  "BLN",
  "BRL",
  "MOA",
  "DSP",
  "TJN",
  "RNT",
  "MLC",
  "RMB",
  "ROH",
  "WOT",
  "PGA",
  "CPK",
  "CPA",
  "MGS"
];

export const unit_type_bw = [
  "Not Available",
  "UT02",
  "UT01",
  "UT08",
  "UT10",
  "UT03",
  "UT04",
  "UT05",
  "UT07",
  "UT06",
];

export const segment_category = [
  "Not Available",
  "obsolete",
  "Pet Nutrition",
  "Chocolate",
  "Food",
  "Royal Canin",
  "Gum&Confections",
  "Pet Horse",
  "Pet Bird",
  "Pet Fish",
  "Multi-Sales Pet",
  "Multi-Sales MW",
  "Multi-Sales Food",
  "Div001",
  "Corporate",
  "Petcare",
  "Pet Services",
  "Div007",
  "NULL",
  "Nutrition",
  "Mars Wrigley",
  "Pet Litter",
  "KIND",
  "Farms",
  "Health & Wellness",
  "Snacking",
  "Natures Bakery",
  "Tr�Fr�",
];

export const Enterprise = ["Not Available", "Mars Inc"];
export const responsible_segment = [
  "Not Available",
  "Mars Petcare",
  "Mars Snacking",
  "Mars Food & Nutrition",
  "obs. Drinks",
  "Mars Corporate",
];
export const responsible_division = [
  "Not Available",
  "Global Pet Nutrition Division",
  "Mars Wrigley Division",
  "Not Applicable",
  "Global Royal Canin Division",
  "Science & Diagnostics Division",
  "Mars Veterinary Health Division",
  "Kinship Division",
  "Mars Health & Wellness Division",
];

export const business_unit = [
  "Anicura BU",
  "Antech BU",
  "Banfield BU",
  "Blue Pearl BU",
  "Champion Petfoods Acquisition BU",
  "Foodspring BU",
  "Global Food BU",
  "Horsecare BU",
  "Kevin's Food BU",
  "KIND Asia BU",
  "KIND EMEA BU",
  "KIND North America BU",
  "Linnaeus BU",
  "Mars Wrigley Asian Sourcing Team",
  "Mars Wrigley China BU",
  "Mars Wrigley Europe & Central Eurasia BU",
  "Mars Wrigley Europe BU",
  "Mars Wrigley GEM BU",
  "Mars Wrigley North America BU",
  "MVH International Asia BU",
  "Natures Bakery BU",
  "Nature's Bakery NA BU",
  "Not Applicable",
  "obs. Pet Nutrition LATAM BU",
  "Pet Nutrition ANZ BU",
  "Pet Nutrition Asia BU",
  "Pet Nutrition Brazil BU",
  "Pet Nutrition China BU",
  "Pet Nutrition Europe BU",
  "Pet Nutrition India BU",
  "Pet Nutrition Japan BU",
  "Pet Nutrition Mexico BU",
  "Pet Nutrition NA BU",
  "Pet Nutrition SEA BU",
  "Pet Nutrition South Latam BU",
  "Point of Care BU",
  "Pretty Litter Acquisition BU",
  "RC Asia Pacific BU",
  "RC Europe BU",
  "RC North Americas BU",
  "RC Rapid Growth BU",
  "RC Rapid Growth Markets  BU",
  "RC Russia BU",
  "Symbioscience BU",
  "TruFru NA BU",
  "VCA BU",
  "Waltham Pet Science Institute BU",
  "Whistle BU",
  "Wisdom Health BU"
];

export const responsible_division_id = [
  "Not Available",
  "Div007",
  "Div001",
  "Div008",
  "Div003",
  "Div004",
  "Div006",
  "Div005",
  "Div002",
];

export const business_unit_id = [
  "Not Available",
  "BU034",
  "BU108",
  "BU061",
  "BU066",
  "BU020",
  "BU078",
  "BU062",
  "BU004",
  "BU067",
  "BU044",
  "BU037",
  "BU009",
  "BU106",
  "BU025",
  "BU039",
  "BU074",
  "BU035",
  "BU073",
  "BU080",
  "BU032",
  "BU014",
  "BU065",
  "BU109",
  "BU110",
  "BU003",
  "BU036",
  "BU111",
  "BU038",
  "BU064",
  "BU023",
  "BU098",
  "BU081",
  "BU011",
  "BU030",
  "BU017",
  "BU051",
  "BU083",
  "BU099",
  "BU026",
  "BU043",
  "BU006",
  "BU013",
  "BU010",
  "BU019",
  "BU022",
  "BU024",
  "BU021",
  "BU082",
  "BU027",
  "BU031",
  "BU049",
  "BU045",
  "BU012",
  "BU005",
  "BU028",
  "BU107",
  "BU105",
  "BU029",
  "BU072",
  "BU052",
  "BU041",
  "BU001",
  "BU002",
  "BU047",
  "BU048",
  "BU042",
  "BU046",
  "BU068",
  "BU008",
  "BU084",
  "BU085",
  "BU087",
  "BU050",
  "BU086",
  "BU100",
  "BU054",
  "BU060",
  "BU070",
  "BU075",
  "BU076",
  "BU097",
  "BU088",
  "BU089",
  "BU091",
  "BU092",
  "BU090",
  "BU095",
  "BU096",
  "BU101",
  "BU102",
  "BU104",
  "BU103",
];

export const sub_business_unit_id = [
  "Not Available",
  "Not Applicable",
  "Mars Retail Group sub-BU",
  "obs. Cocoa Exchange sub-BU",
  "Birdcare sub-BU",
  "Mars Wrigley Choco Drinks & Treats sub- BU",
  "Fishcare sub-BU",
  "Ethel M sub-BU",
  "obs. Petcare Andean sub-BU",
  "obs. Petcare Southern Cone sub-BU",
  "obs. Petcare Brazil sub-BU",
  "obs. Petcare Mexico sub-BU",
  "obs. Petcare Care & Treats sub-BU",
  "obs. Mars Veterinary sub-BU",
  "obs. Pet Partners sub-BU",
  "Experience Store sub-BU",
  "obs. Mars Cocoa Enterprise sub-BU",
  "Nom Nom Now sub-BU",
  "KIND Frozen sub-BU",
];
